import { Visitor } from '../../visitor';
import { ApiPostRequest } from './api-post-request';

export interface VisitorValidationPayload {
    dateofbirth: string;
    check: string;
}

export class VisitorValidationRequest extends ApiPostRequest {
    public constructor(player: Visitor, webapiBasepath: string) {
        const { dateofbirth, check } = VisitorValidationRequest.parseCprData(player?.Cpr);

        const payload: VisitorValidationPayload = {
            dateofbirth,
            check,
        };

        super('playervalidation', null, null, payload, webapiBasepath);
    }

    private static parseCprData(cpr: string | undefined): { dateofbirth: string; check: string } {
        if (!cpr) {
            return { dateofbirth: '', check: '' };
        }

        // CPR with dash format: DDMMYY-XXXX
        if (cpr.includes('-')) {
            const [dob, checkSum] = cpr.split('-');
            return { dateofbirth: dob || '', check: checkSum || '' };
        }

        // CPR without dash format: DDMMYYXXXX (must be exactly 10 digits)
        if (cpr.length === 10) {
            return {
                dateofbirth: cpr.slice(0, 6),
                check: cpr.slice(6)
            };
        }

        // Invalid CPR format
        return { dateofbirth: '', check: '' };
    }
}
